"use client";

import {
  useEffect,
  useEffectEvent,
  useState,
  type ReactNode,
} from "react";
import { TABLET_BREAKPOINT } from "@/hooks/use-mobile";

export function useResetAboveWidth(minWidth: number, onCross: () => void) {
  const reset = useEffectEvent(onCross);

  useEffect(() => {
    const query = window.matchMedia(`(min-width: ${minWidth}px)`);
    const onChange = () => {
      if (query.matches) reset();
    };
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, [minWidth]);
}

export function useIsDesktopViewport(): boolean | undefined {
  return useMatchesMedia(`(min-width: ${TABLET_BREAKPOINT}px)`);
}

function useMatchesMedia(query: string): boolean | undefined {
  const [matches, setMatches] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

export function LgUpOnly({ children }: { children: ReactNode }) {
  const matches = useMatchesMedia(`(min-width: ${TABLET_BREAKPOINT}px)`);
  return matches === true ? <>{children}</> : null;
}

export function BelowLgOnly({ children }: { children: ReactNode }) {
  const matches = useMatchesMedia(`(min-width: ${TABLET_BREAKPOINT}px)`);
  return matches === false || matches === undefined ? <>{children}</> : null;
}
